import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { Scroll } from '@phosphor-icons/react';
import { useState } from 'react';
import KitModal from '../UI/KitModal';
import LoadingSpinner from '../UI/LoadingSpinner';

type Props = {
  onHide: () => void;
  show: boolean;
  flow: any;
  isCreateFormLoading: boolean;
  onCreateForm: (name: string, useAgent: boolean) => void;
};

const CreateFormModal = ({
  onHide,
  show,
  flow,
  isCreateFormLoading,
  onCreateForm,
}: Props) => {
  const [name, setName] = useState('');
  const [useAgent, setUseAgent] = useState(false);

  return (
    <KitModal
      onHide={onHide}
      show={show}
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '520px',
          borderRadius: '8px',
        },
        '& .MuiDialogContent-root': {
          padding: '32px',
        },
        '& .MuiDialogActions-root': {
          padding: '32px',
        },
      }}
      showCloseButton={false}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        gap="1rem"
      >
        <Box display="flex" gap="16px" alignItems="center">
          <Box
            p={'2px'}
            bgcolor={'#E7F0FF'}
            display={'flex'}
            alignContent={'center'}
            justifyContent={'center'}
          >
            <Scroll color="#3650DE" size={32} />
          </Box>
          <Typography fontSize={'32px'} color={'#101828'}>
            Create your interface
          </Typography>
        </Box>
        <Typography
          sx={{
            color: '#475467',
            fontSize: '16px',
            fontWeight: 400,
          }}
        >
          You're crafting an interface based on the{' '}
          <span
            style={{
              textTransform: 'capitalize',
            }}
          >
            {'"'}
            {flow?.name || 'Untitled'}
            {'" '}
          </span>
          existing agent.
        </Typography>
        <TextField
          id="outlined-basic"
          label="Enter Interface Name"
          variant="outlined"
          placeholder="Interface's name"
          type="text"
          name="name"
          value={name}
          onChange={e => setName(e.target.value)}
          fullWidth
        />

        <Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={useAgent}
                onChange={e => setUseAgent(e.target.checked)}
              />
            }
            label='Use the form builder agent'
          />
          <Typography
            sx={{
              color: '#475467',
              fontSize: '14px',
              fontWeight: 400,
              marginLeft: '32px',
              marginTop: '-8px',
            }}
          >
            The agent will create a form tailored to the flow. This may take a while.
          </Typography>
        </Box>

        <Button
          disabled={!name || isCreateFormLoading}
          fullWidth
          onClick={() => {
            setName('');
            onCreateForm(name, useAgent);
          }}
          variant={`contained`}
          size="small"
        >
          {isCreateFormLoading ? (
            <>
              <LoadingSpinner size={16} />
            </>
          ) : (
            'Continue'
          )}
        </Button>
      </Box>
    </KitModal>
  );
};

export default CreateFormModal;
